module.exports = __webpack_public_path__ + "static/media/icon-more.9b68e0f2.svg";